export default "__VITE_ASSET__BSbcvLdr__"